import { type UseQueryResult, useQuery } from 'react-query';
import {
  AwardAgreementDocumentImportService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetAwardDocByAwardId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto[] | undefined,
  unknown
> => {
  const awardDocByAwardId = useQuery(['getAwardDocByAwardId', id], async () => {
    if (id) {
      return await handleRequest(
        AwardAgreementDocumentImportService.getApiAwardApiAppAwardAgreementDocumentImportAwardDocumentsByAwardId(
          id
        )
      );
    }
  });

  return awardDocByAwardId;
};

export default useGetAwardDocByAwardId;
